export default {
  getToken
};

function getToken () {
  return localStorage.getItem('jwtToken') || ''
}
